import { Box, Chip, styled } from '@mui/material';

export const EntitySearchFilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 2, 2, 2)
}));

export const FilterChip = styled(Chip)(({ theme }) => ({
  height: '20px',
  border: '1px solid transparent',
  color: theme.palette.text.primary,
  '&.MuiChip-filled': {
    backgroundColor: theme.vars.palette.surface.containerLow,
    borderColor: theme.vars.palette.primary.main,
    color: theme.vars.palette.primary.main
  },
  '&.MuiChip-outlined': {
    borderColor: 'transparent'
  }
}));
